import React from 'react';
import { Navigate } from 'react-router-dom';
import { getSessionRole } from '../services/authSession';

// Protege rotas por papel: se o role da sessão não estiver em allowedRoles, redireciona para redirectTo.
function RoleGuard({ allowedRoles, redirectTo = '/app', children }) {
  const role = getSessionRole();
  const isAllowed = !allowedRoles || allowedRoles.includes(role);

  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default RoleGuard;
